module.exports = __webpack_public_path__ + "img/高新技术企业.d3aae15a.jpg";